// extracted by mini-css-extract-plugin
module.exports = {"Footer":"hvs__Footer__omm6XVTI","Logo":"hvs__Logo__5ETEuHBO","Content":"hvs__Content__1TBpc7TW"};